import React from "react";
import { List, Typography } from "antd";

export default function LeadMessages({ messages = [] }) {
  if (!messages.length) {
    return <Typography.Text type="secondary">אין הודעות עדיין</Typography.Text>;
  }
  return (
    <List
      size="small"
      dataSource={messages}
      renderItem={(m) => (
        <List.Item key={m.id}>
          <div style={{ width: "100%" }}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {m.sender_type} · {m.created_at}
            </Typography.Text>
            <div>{m.message_text}</div>
          </div>
        </List.Item>
      )}
    />
  );
}
